module.exports = __webpack_public_path__ + "static/media/Axel R.J. Beck@2x.0920a6e3.jpg";